<template>
    <div>
        <div v-if="createdMessage" class="alert alert-success">Fakutra {{ createdMessage }} została dodana.</div>
        <div v-if="updateMessage" class="alert alert-success">Fakutra {{ updateMessage }} została zmodyfikowana.</div>
        <div>
            <b-button @click="addNewInvoice" variant="default">
                <span>Dodaj fakturę</span>
                <svg-icon name="plus"/>
            </b-button>
        </div>

        <b-modal ref="createInvoiceModal" size="lg" hide-footer :title="invoiceModalTitle">
            <alert-loading v-if="loading"></alert-loading>
            <form-factored-invoice v-if="!loading" ref="formFactoredInvoice"
                                   :handle-submit="handleSubmit"
                                   :currencyName="currencyName"
                                   :errors="errors"
                                   :values="item"
            ></form-factored-invoice>
            <b-row v-if="!loading">
                <b-col>
                    <b-button class="mt-3" variant="primary" block @click="hideModal"><span>Anuluj</span>
                        <svg-icon name="back"/>
                    </b-button>
                </b-col>
                <b-col>
                    <b-button class="mt-3" variant="default" block @click="saveInvoice"><span>Zapisz</span>
                        <svg-icon name="tick"/>
                    </b-button>
                </b-col>
            </b-row>
        </b-modal>

        <invoice-list :id="$route.params.id" ref="invoiceList" :showEditButton="true"
                      :editAction="editInvoice"></invoice-list>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import invoiceList from './invoiceList.vue'
  import FormFactoredInvoice from './FormFactoredInvoice.vue'

  export default {
    components: {
      'invoice-list': invoiceList,
      'form-factored-invoice': FormFactoredInvoice
    },
    data: function () {
      return {
        tabIndex: 0,
        item: {},
        createdMessage: null,
        updateMessage: null,
        isEditing: false
      }
    },
    computed: {
      invoiceModalTitle(){
        return this.isEditing ? 'Edytuj fakturę': 'Dodaj fakturę' ;
      },
      errors () {
        return this.createdViolations ? this.createdViolations : this.updateViolations ? this.updateViolations : {}
      },
      loading () {
        return this.createdLoading || this.retrieveLoading  || this.updateLoading
      },
      currencyName () {
        if (this.retrieved != null) {
          return this.retrieved.currency.name
        }
        else {
          return '...'
        }
      },
      ...mapGetters({
        retrieveLoading: 'agreement/update/retrieveLoading',
        retrieved: 'agreement/update/retrieved',
        created: 'factoredinvoice/create/created',
        createdViolations: 'factoredinvoice/create/violations',
        createdLoading: 'factoredinvoice/create/loading',
        createdError: 'factoredinvoice/create/error',
        updated: 'factoredinvoice/update/updated',
        updateViolations: 'factoredinvoice/update/violations',
        updateLoading: 'factoredinvoice/update/updateLoading',
        updateError: 'factoredinvoice/update/error',
      })
    },
    methods: {
      editInvoice (item) {
        this.$store.dispatch('factoredinvoice/create/reset')
        this.$store.dispatch('factoredinvoice/update/reset')
        this.item = item
        this.isEditing = true
        this.$refs.createInvoiceModal.show()
      },
      saveInvoice () {
        this.$refs.formFactoredInvoice.sendForm()
      },
      addNewInvoice () {
        this.$store.dispatch('factoredinvoice/create/reset')
        this.$store.dispatch('factoredinvoice/update/reset')
        this.item = {}
        this.isEditing = false
        this.$refs.createInvoiceModal.show()
      },
      hideModal () {
        this.$refs.createInvoiceModal.hide()
      },
      handleSubmit (item) {
        item.agreement = this.retrieved['@id']
        this.item = item
        if (this.isEditing) {
          this.$store.dispatch('factoredinvoice/update/update', item)
        } else {
          this.$store.dispatch('factoredinvoice/create/create', item)
        }
      }
    },
    watch: {
      'created': function (data) {
        if (data != null) {
          this.hideModal()
          this.createdMessage = data.number
          setTimeout(() => {
            this.createdMessage = null
          }, 5000)
          this.$refs.invoiceList.getInvoiceList()
        }
      },

      'updated': function (data) {
        if (data != null) {
          this.hideModal()
          this.updateMessage = data.number
          setTimeout(() => {
            this.updateMessage = null
          }, 5000)
          this.$refs.invoiceList.getInvoiceList()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UpdateInvoice.vue?2e1f065b